export default "__VITE_ASSET__336bfb74__"